import React from "react";
import Container from "react-bootstrap/Container";
import { withRouter } from "react-router-dom";
import routes from "../../../routes/routes";
import Topbar from "../../organisms/Topbar/Topbar";
import Navbar from "../../organisms/Navbar/Navbar";
import SmallNavigation from "../../organisms/SmallNavigation/SmallNavigation";
import Footer from "../../organisms/Footer/Footer";
import BottomBar from "../../organisms/BottomBar/BottomBar";
import RouterView from "../../organisms/RouterView/RouterView";
import CarouselRibbon from "../../organisms/CarouselRibbon/CarouselRibbon";
import Marquee from "../../molecules/Marquee/Marquee";

const includeSmallNavigation = [
  "parts",
  "details",
  "search",
  "features",
  "distributors",
  "info",
  "faq",
];

const MainLayout = ({ location }) => (
  <>
    <Topbar />
    <Marquee />
    <Navbar />
    <Container>
      <CarouselRibbon />
    </Container>
    {includeSmallNavigation.some((item) =>
      location.pathname.includes(item)
    ) && <SmallNavigation />}
    <RouterView routes={routes} />
    <Footer />
    <BottomBar />
  </>
);

export default withRouter(MainLayout);
